import MDTypography from 'components/MDTypography'
import ModalDialog from '../modal-dialog/ModalDialog'

const TITLE = 'לא ניתן לערוך את הפרט'

const CLOSE_LABEL = 'סגירה'

const REASONS = {
    marketing: 'לא ניתן לערוך פרט המאושר לשיווק. אפשר לערוך אותו רק לאחר ביטול הסימון "לשיווק". מומלץ להוסיף פרט חדש במקומו.',
    unsubscribed: 'לא ניתן לערוך פרט של נמען שהוסר מהתפוצה. מומלץ להוסיף פרט חדש במקומו.',
}

export default function DetailEditRefusal({ reason = null, onClose }) {
    if (reason == null) {
        return null
    }

    return (
        <ModalDialog
            open
            title={TITLE}
            commands={[
                {
                    label: CLOSE_LABEL,
                    color: 'secondary',
                    onClick: onClose,
                },
            ]}
            onClose={onClose}
        >
            <MDTypography variant="body2">
                {REASONS[reason]}
            </MDTypography>
        </ModalDialog>
    )
}
